import { Component, Input, OnInit, OnDestroy, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { StoreService, CoreFiltersService } from 'core/services';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'lms-list-filter-row',
  templateUrl: './list-filter-row.component.html',
  styleUrls: ['./list-filter-row.component.scss']
})
export class ListFilterRowComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() listId: string;
  @Output() filter = new EventEmitter<Object>();
  showFilterRow: boolean = false;
  columns: any[];
  filtersForm: UntypedFormGroup;
  filters: any;

  listSubscription: Subscription;
  listFilters: Map<string, string>;

  @Input() headers: any;

  constructor(public filtersService: CoreFiltersService) {}

  ngOnInit() {
    this.filtersForm = new UntypedFormGroup({});
    this.listSubscription = StoreService.get(this.listId).subscribe((data) => {
      this.showFilterRow = data && data.showFilterRow;
      if (!this.columns) {
        this.setFilterQuestions();
      }
      if (data && data.filters) {
        this.listFilters = data.filters;
        this.setFilterValues();
      }
      if (!this.showFilterRow) {
        this.filtersForm.reset();
      }
    });
    // this.setFilterQuestions();
  }

  setFilterQuestions() {
    this.columns = [...this.headers.children].map((child) => {
      const { nodeName, className } = child;
      const column = {
        className,
        label: ''
      };
      if (nodeName.toLowerCase() === 'lms-list-header') {
        const field = child.attributes.getNamedItem('field');
        const name = field.value;
        column['name'] = name;
        // if (this.listFilters && this.listFilters.has(name)) {
        //   column['value'] = this.listFilters.get(name);
        //   // this.listFilters.delete(name);
        // }
      }
      return column;
    });
    this.filters = this.filtersService.createFilters({ scheme: this.columns });
  }

  setFilterValues() {
    if (!this.columns) return;

    const formValues = this.columns.reduce((values, col) => {
      if (this.listFilters.has(col.name)) {
        const v = { ...values };
        v[col.name] = this.listFilters.get(col.name);
        this.filters[col.name].question.value = this.listFilters.get(col.name);
        this.listFilters.delete(col.name);
        return v;
      }
      return values;
    }, null);

    if (formValues && !this.listFilters.has('$filter')) {
      this.applyFilters(formValues);
    }
  }

  ngAfterViewInit(): void {
    this.filtersForm.valueChanges.subscribe((data) => this.applyFilters(data));
  }

  ngOnDestroy() {
    if (this.listSubscription) {
      this.listSubscription.unsubscribe();
    }
  }

  applyFilters(values) {
    if (!this.showFilterRow) return;
    const lastFilter = this.listFilters && this.listFilters.get('$filter') ? this.listFilters.get('$filter') : '';
    const $filter = this.filtersService.buildFilterString(values, this.filters);
    if (lastFilter !== $filter) {
      const filters = new Map<string, string>(this.listFilters);
      filters.set('$filter', $filter);
      StoreService.merge(this.listId, { filters, page: 1, active: true });
      this.filter.emit(filters);
    }
  }
}
